import { postJSON, postFORM, postChatJson, upload, postChatFORM, chatGET, GET } from "@/utils/http/request";



/**
 * 登录通讯系统
 * @param params 请求参数
 * @returns
 */
export const loginChat = (params: any) => {
  return postChatJson(`/v1/auth/login/sign`, params);
};

/**
 * 创建会话
 * @param params 请求参数
 * @returns
 */
export const createSession = (params: any) => {
  return postChatJson(`/v1/im/sessions`, params);
};

/**
 * 获取会话
 * @param params 请求参数
 * @returns
 */
export const findSessionById = (sessionId: number) => {
  return chatGET(`/v1/im/sessions/${sessionId}`);
};

/**
 * 获取会话列表
 * @param params 请求参数
 * @returns
 */
export const findSessionList = (params: any) => {
  return postChatJson(`/v1/im/sessions/search`, params);
};

/**
 * 分页获取消息列表
 * @param params 请求参数
 * @returns
 */
export const findMessagePage = (params: any) => {
  return postChatJson(`/v1/im/messages/search`, params);
};


/**
 * 创建群
 * @param params 请求参数
 * @returns
 */
export const createGroupInfo = (params: any) => {
  return postChatJson(`/v1/im/groups`, params);
};

/**
 * 创建群
 * @param params 请求参数
 * @returns
 */
export const createJobGroupInfo = (params: any) => {
  return postChatFORM(`/v1/im/groups/job`, params);
};

/**
 * 加入群聊
 * @param params 请求参数
 * @returns
 */
export const joinGroup = (params: any) => {
  return postChatJson(`/v1/im/groups/join`,params);
};


/**
 * 获取群聊
 * @param params 请求参数
 * @returns
 */
export const findGroupById = (groupId: number) => {
  return chatGET(`/v1/im/groups/${groupId}`);
};

/**
 * 编辑群聊
 * @param params 请求参数
 * @returns
 */
export const editGroup = (params: any) => {
  return postChatJson(`/v1/im/groups/edit`,params);
};

/**
 * 移除群聊成员
 * @param params 请求参数
 * @returns
 */
export const removeGroupUser = (params: any) => {
  return postChatJson(`/v1/im/groups/remove/user`,params);
};

/**
 * 移除群聊成员
 * @param params 请求参数
 * @returns
 */
export const removeGroup = (groupId: number) => {
  return postChatJson(`/v1/im/groups/${groupId}/remove`);
};

/**
 * 设置群聊人员禁言
 * @param params 请求参数
 * @returns
 */
export const muteGroupUser = (params: any) => {
  return postChatJson(`/v1/im/groups/mute/user`,params);
};

/**
 * 设置群聊人员管理员权限
 * @param params 请求参数
 * @returns
 */
export const groupUserAdmin = (params: any) => {
  return postChatJson(`/v1/im/groups/user/admin`,params);
};

/**
 * 获取表情
 * @param params 请求参数
 * @returns
 */
export const obtainChatEmojiAll = () => {
  return chatGET(`/v1/im/emoji`);
};


/**
 * 获取常用聊天语
 * @param params 请求参数
 * @returns
 */
export const obtainChatTellAll = () => {
  return chatGET(`/v1/im/tell`);
};


